import React, { lazy, Suspense } from "react";
import { RouteObject } from "react-router-dom";

// Lazy‑load pages
const HomePage = lazy(() => import("../pages/home/page"));
// const InvestPage = lazy(() => import("../pages/invest/page"));
// const PromissoryPage = lazy(() => import("../pages/promissory/page"));
// const BlogPage = lazy(() => import("../pages/blog/page"));
// const BlogPostPage = lazy(() => import("../pages/blog-post/page"));
// const LandingPage = lazy(() => import("../pages/landing/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
// const AuthorPage = lazy(() => import("../pages/author/page"));
// const DirectoryPage = lazy(() => import("../pages/directory/page"));

/**
 * Helper to wrap a lazily‑loaded component with a fallback.
 * This keeps the route definitions clean and adds a safety net
 * in case a component fails to load.
 */
const withSuspense = (
  Component: React.LazyExoticComponent<React.ComponentType<any>>,
) => (
  <Suspense fallback={null}>
    <Component />
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: "/",
    element: withSuspense(HomePage),
  },
  // {
  //   path: "/invest",
  //   element: withSuspense(InvestPage),
  // },
  // {
  //   path: "/promissory",
  //   element: withSuspense(PromissoryPage),
  // },
  // {
  //   path: '/blog',
  //   element: withSuspense(BlogPage),
  // },
  // {
  //   path: '/blog/:slug',
  //   element: withSuspense(BlogPostPage),
  // },
  // {
  //   path: '/blog/featured-article',
  //   element: withSuspense(BlogPostPage),
  // },
  // {
  //   path: '/author/thomas-hood',
  //   element: withSuspense(AuthorPage),
  // },
  // {
  //   path: '/author/:slug',
  //   element: withSuspense(AuthorPage),
  // },
  // {
  //   path: '/directory',
  //   element: withSuspense(DirectoryPage),
  // },
  // {
  //   path: '/landing',
  //   element: withSuspense(LandingPage),
  // },
  {
    path: "*",
    element: withSuspense(NotFound),
  },
];

export default routes;
